import type React from 'react';
import type { Program } from '@shared/types/programs';
import { PromoImage } from '../promo-image';
import { PromoPlayer } from '../promo-player';

type Props = {
  program?: Program;
};

export const ProgramPromo: React.FC<Props> = ({ program }) => {
  // const { program } = useProgram(id);
  if (program) {
    return program.promo_video && typeof program.promo_video !== 'number' ? (
      <PromoPlayer video={program.promo_video} />
    ) : (
      <PromoImage url={program.promo_image} />
    );
  }
};
